import "datatables.net";
import "../components/hs-datatables";
import "flatpickr";
import "../components/hs-range-datepicker";
import "../components/hs-selectpicker";
import "../components/hs-chart-pie";
import "../components/hs-progress-bar";

export default {
  init() {

  },
  finalize() {

    $(".remove-search-staff").on("click", function () {
        var search_id = $(this).data("search-id");
        var action="removesearchdatabase";
        var url = ajaxdta.ajaxurl + "?action=remove_search_id";
      
        $.ajax({
          type: "POST",
          url: url,
          data: {
            search_id: search_id, action:action
          },
          dataType:"JSON",
          success: function (data) { 
            var mString = data.count;  
            if(mString)  {
              $("#search"+ search_id).hide();   
            }else{
              $("html, body").animate({scrollTop: 0}, 'slow');
              $(".errormessage").html("* Error in deleting the search");
              $(".errormessage").fadeOut(10000);
            }          
          },
        });
      });

      $(".edit-search-name").on("click", function () {
        var searchid = $(this).data("search-id");
        $("#search_name"+ searchid).show(); 
        $("#searchname"+ searchid).hide(); 
        $(".pencilbuttonsearch").hide();
    });

    $(".searchnameinput").focusout(function(){
      var searchid = $(this).data("search-id");
      var searchname = $("#search_name"+ searchid).val();
      var searchid = $('#searchid'+ searchid).val();
      var url = ajaxdta.ajaxurl + "?action=rename-search";
      var action="renamesearch";

      $.ajax({
        type: "POST",
        url: url,
        data: {
          searchname: searchname, searchid:searchid, action:action
        },
        dataType:"JSON",
        success: function (data) { 
          var mString = data.count;
          if(mString)  {
            window.location.reload(); 
          }else{
            $("html, body").animate({scrollTop: 0}, 'slow');
            $(".errormessage").html("* Error in renaiming search");
            $(".errormessage").fadeOut(10000);
          }   
        },
      });

  
    });
},
};



// WEBPACK FOOTER //
// ./scripts/routes/training-plan-builder-searches.js